import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, Users, FileText, LayoutDashboard, Plus, Instagram } from "lucide-react";
import { crm, clearToken, getToken } from "../lib/crmClient";

export default function CrmShell() {
    const nav = useNavigate();
    const [me, setMe] = useState(null);

    useEffect(() => {
        if (!getToken()) {
            nav("/crm/login");
            return;
        }
        crm.get("/auth/me")
            .then((r) => setMe(r.data))
            .catch(() => nav("/crm/login"));
    }, [nav]);

    const logout = () => {
        clearToken();
        nav("/crm/login");
    };

    const linkClass = ({ isActive }) =>
        `flex items-center gap-3 px-4 py-3 font-mono text-[11px] tracking-[0.28em] uppercase transition-colors ${
            isActive
                ? "text-[#FFE600] border-l-2 border-[#FFE600] bg-[#FFE600]/[0.05]"
                : "text-white/60 hover:text-white border-l-2 border-transparent"
        }`;

    return (
        <div
            data-testid="crm-shell"
            className="min-h-screen bg-black text-white flex flex-col md:flex-row"
        >
            <aside className="md:w-64 md:min-h-screen border-b md:border-b-0 md:border-r border-white/10 flex flex-col">
                <Link to="/" className="p-6 border-b border-white/10 block">
                    <div className="font-mono text-[9px] tracking-[0.3em] uppercase text-[#FFE600]">
                        PaintKing · CRM
                    </div>
                    <div className="font-display uppercase text-2xl leading-none mt-2">
                        Command Center
                    </div>
                </Link>
                <nav className="py-4 flex-1">
                    <NavLink to="/crm" end className={linkClass}>
                        <LayoutDashboard className="w-4 h-4" /> Dashboard
                    </NavLink>
                    <NavLink to="/crm/clients" className={linkClass}>
                        <Users className="w-4 h-4" /> Clients
                    </NavLink>
                    <NavLink to="/crm/invoices" className={linkClass}>
                        <FileText className="w-4 h-4" /> Invoices & Quotes
                    </NavLink>
                    <NavLink to="/crm/invoices/new" className={linkClass}>
                        <Plus className="w-4 h-4" /> New Invoice
                    </NavLink>
                    <NavLink to="/crm/instagram" className={linkClass}>
                        <Instagram className="w-4 h-4" /> Instagram Feed
                    </NavLink>
                </nav>
                <div className="p-4 border-t border-white/10 flex items-center justify-between">
                    <div>
                        <div className="font-mono text-[9px] tracking-[0.28em] uppercase text-white/40">
                            Signed in
                        </div>
                        <div className="font-display uppercase text-sm mt-1" data-testid="crm-me-name">
                            {me?.name || me?.email || "—"}
                        </div>
                    </div>
                    <button
                        data-testid="crm-logout"
                        onClick={logout}
                        className="p-2 border border-white/20 hover:border-white/60 transition-colors"
                        aria-label="Sign out"
                    >
                        <LogOut className="w-4 h-4" />
                    </button>
                </div>
            </aside>

            <main className="flex-1 p-6 md:p-10">
                <Outlet />
            </main>
        </div>
    );
}
